var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM9.81961 7.76607C9.43208 8.24427 9.30039 8.83274 9.30039 9.19846C9.30039 9.69552 8.89745 10.0985 8.40039 10.0985C7.90333 10.0985 7.50039 9.69552 7.50039 9.19846C7.50039 8.49803 7.7287 7.48727 8.42117 6.63278C9.1445 5.7402 10.3094 5.1 12.0004 5.1C13.6544 5.1 14.8102 5.65334 15.5455 6.4598C16.2555 7.23865 16.5004 8.17468 16.5004 8.84308C16.5004 9.44963 16.4246 10.1704 15.9682 10.863C15.5161 11.5491 14.7716 12.0869 13.6847 12.5217C12.9657 12.8095 12.6097 13.0509 12.4333 13.2397C12.2964 13.3861 12.2443 13.5218 12.2443 13.7526C12.2443 14.2497 11.8413 14.6526 11.3443 14.6526C10.8472 14.6526 10.4443 14.2497 10.4443 13.7526C10.4443 13.1221 10.6331 12.5295 11.1183 12.0105C11.5639 11.5338 12.2111 11.1727 13.016 10.8506C13.9059 10.4945 14.2865 10.1438 14.4652 9.87259C14.6395 9.608 14.7004 9.30268 14.7004 8.84308C14.7004 8.56379 14.5852 8.07827 14.2153 7.6725C13.8705 7.29435 13.2264 6.9 12.0004 6.9C10.8114 6.9 10.1763 7.32595 9.81961 7.76607ZM11.3328 17.9996C11.9956 17.9996 12.5328 17.4624 12.5328 16.7996C12.5328 16.1369 11.9956 15.5996 11.3328 15.5996C10.6701 15.5996 10.1328 16.1369 10.1328 16.7996C10.1328 17.4624 10.6701 17.9996 11.3328 17.9996Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.9cbf8234b296015a8ed53cdde5837483.svg";
export { ForwardRef as ReactComponent };